//import { createElement } from "react";
import moment from 'moment';
import {setConfig} from './serviceconfig';

const ServiceData = setConfig({});

export const tuples = (jso:any) => Object.keys(jso).map(key => ({k:key,v:jso[key]}));

export const ucfirst = (lower:string) => lower.replace(/^\w/, (c) => c.toUpperCase());
 
export const clone = (config:any) => {
  var sd = Object.assign({},ServiceData,config); 
  sd.service = Object.assign( {},ServiceData.service,config.service);
  var serviceforms = (sd.service.eform).reduce((acc:any,v:any)=> {
    Object.keys(acc).map(k=>acc[k].push([v.id,v.label,v.type,v.req,v.ops]));
    return acc;
  },{add:[],edit:[],view:[]});
  sd.service = Object.assign( {},ServiceData.service,serviceforms,config.service);
  var init = sd.service.num?[{id:'id',numeric:false,disablePadding:true,label:'No'}]:[];
  sd.service.cols = sd.service.grid.reduce((ac:any,va:any)=>{
    ac.push({id:va[0],numeric:false,disablePadding:true,label:va[1]});
    return ac;
  },init);
  return sd;
}; 

export const formatDate = (id:any) => {  //id must be isostamp 
  return moment(id).format('DD-MMM-YYYY HH:mm');
};

export const formatStatus = (type: string) => (id: any) => {
  const names:any = {
    form: ['disabled', 'active', 'stopped'],
    grid: ['disabled', 'active', 'stopped'],
  }

  let name = names[type||'form'][id] || 'unknown';
  return name;
};

export const getSource = (id:any,rec:any) => {
  if(rec.dsc === "") return null;
  const it = JSON.parse(rec.dsc) || {};
  return it.src||'None';
};

export const clamp = (value:number, min = 0, max = 100) =>{
  return Math.min(Math.max(value, min), max);
};

//export {tuples,ucfirst,clone,clamp,formatDate,getSource};

export const isArray = (arg:any) => {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

export const isObject = (arg:any) => {
  return Object.prototype.toString.call(arg) === '[object Object]';
};

export const isFunction = (arg:any) => {
  return typeof arg === 'function';
};

const funcs = {tuples,ucfirst,clone,clamp,formatDate,getSource,isArray,isObject,isFunction};

export default funcs;
